import { Avatar, Heading, Text } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"
import { PearlHeaderProps } from "./types"

export const PearlHeader = ({ title, subtitle, avatarUrl }: PearlHeaderProps) => {
  const { t } = useTranslation("pearl/PearlHeader")

  return (
    <div>
      <div className="mb-6 flex items-center gap-4">
        <Avatar size="lg" src={avatarUrl ?? "/images/oyster-logo.png"} name={title ?? t("title")} />
        <div>
          <Heading as="h2" size="lg" className="font-bold" id="pearl">
            {title ?? t("title")}
          </Heading>
          <Text size="small" className="text-gray-400">
            {subtitle ?? t("subtitle")}
          </Text>
        </div>
      </div>
    </div>
  )
}
